import useDataManagementList from '@/views/pages/data-management/data-management-list/hooks/useDataManagementList';

import { onBeforeMount } from '@vue/composition-api';
import usePagination from '@/views/components/pagination/usePagination';

import usePermissionByAccount from "@/constants/navigation/BOYNYKJMS2EH/permission-by-account"

export default function useBannerList() {
  const { getPermissionModule } = usePermissionByAccount()
  const { dynamicBIConfig, dynamicTableConfig } = useDataManagementList();
  const { pagination } = usePagination();

  return { dynamicBIConfig, dynamicTableConfig, pagination, getPermissionModule };
}
